import { AppBar, Toolbar } from "@mui/material";
import React from "react";

function Footer() {
  return <div className="footer-container">Footer Section</div>;
}

export default Footer;
